import { ResponsiveContainer, ComposedChart, Bar, Line, XAxis, YAxis, Tooltip, Legend, CartesianGrid, LabelList } from "recharts";
import { BarChart3 } from "lucide-react";

const COLORS = ["#1F8A7C", "#5CC4B4", "#9AB0B8", "#B7791F", "#13212A"];
const k$ = (v) => (v >= 1000 ? `$${(v / 1000).toFixed(1)}k` : `$${Math.round(v)}`);
const LBL = { fontSize: 9, fontFamily: "JetBrains Mono, monospace", fill: "#13212A" };

export const AnswerChart = ({ chart, idx = 0 }) => {
  const series = chart.series || [];
  const data = (chart.labels || []).map((l, i) => Object.fromEntries([["label", l], ...series.map((s, j) => [`s${j}`, s.values?.[i] ?? null])]));
  const hasRight = series.some((s) => s.axis === "right");
  const stacked = chart.type === "stacked";
  return (
    <div className="card" style={{ padding: 14, marginTop: 12, background: "var(--surface)" }} data-testid={`ai2-chart-${idx}`}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8, fontSize: 13, fontWeight: 700 }}><BarChart3 size={14} color="#1F8A7C" />{chart.title}</div>
      <div style={{ height: 240 }}>
        <ResponsiveContainer>
          <ComposedChart data={data} margin={{ top: 18, right: 4, left: -12, bottom: 0 }}>
            <CartesianGrid vertical={false} stroke="#E6EEEF" />
            <XAxis dataKey="label" tick={{ fontSize: 11 }} minTickGap={6} />
            <YAxis yAxisId="left" tick={{ fontSize: 11 }} tickFormatter={(v) => (series.some((s) => s.money && s.axis !== "right") ? k$(v) : v)} />
            {hasRight && <YAxis yAxisId="right" orientation="right" tick={{ fontSize: 11 }} tickFormatter={k$} />}
            <Tooltip formatter={(v, n, p) => (series[Number(p.dataKey.slice(1))]?.money ? `$${Number(v).toLocaleString()}` : v)} />
            <Legend wrapperStyle={{ fontSize: 12 }} formatter={(v) => <span style={{ color: "#13212A" }}>{v}</span>} />
            {series.map((s, j) => {
              const axis = s.axis === "right" ? "right" : "left";
              const fmt = (v) => (v ? (s.money ? k$(v) : v) : "");
              if (chart.type === "line" || (axis === "right" && !stacked && chart.type !== "bar")) {
                return <Line key={j} yAxisId={axis} dataKey={`s${j}`} name={s.name} stroke={axis === "right" ? "#5B6B73" : COLORS[j % 5]} strokeWidth={2} dot={{ r: 2 }} />;
              }
              return (
                <Bar key={j} yAxisId={axis} dataKey={`s${j}`} name={s.name} fill={COLORS[j % 5]} stackId={stacked && axis === "left" ? "s" : undefined} radius={stacked ? 0 : [3, 3, 0, 0]}>
                  <LabelList dataKey={`s${j}`} position={stacked ? "center" : "top"} formatter={fmt} style={{ ...LBL, fill: stacked && j < 2 ? "#fff" : LBL.fill }} />
                </Bar>
              );
            })}
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
